import { BaseModel, Column, Model } from 'scf-graphql-model'

@Model('vdmoServer')
export class VdmoServer extends BaseModel {
  @Column()
  host: string | undefined
}
